<main class="form-signin" id="anmeldung">
    <div class="card shadow-sm">
        <div class="card-body">
            <form data-bitwarden-watching="1" name="loginform" (ngSubmit)="login()">
                <div class="text-center">
                    <img class="mb-3 img-fluid" src="assets/img/taskradar.png" alt="TaskRadar" style="max-height: 72px;">
                </div>
                <h1 class="h4 mb-3 fw-semibold text-center">Aufgabenmanagement</h1>

                <div class="form-floating mb-2">
                    <input type="text" class="form-control" id="login_email" [(ngModel)]="email" name="email" placeholder="E-Mail">
                    <label for="login_email">E-Mail</label>
                </div>
                <div class="form-floating">
                    <input type="password" class="form-control" id="login_password" [(ngModel)]="password" name="password" placeholder="Passwort">
                    <label for="login_password">Passwort</label>
                </div>

                <button class="w-100 btn btn-lg btn-danger mt-3" type="submit">Anmelden</button>
                <a class="w-100 btn btn-outline-secondary mt-2" routerLink="/landing" aria-label="Zurück zur Startseite">Zurück zur Startseite</a>
            </form>
        </div>
    </div>
</main>
